import type { ExtractedData } from "@/components/AIExtractionReviewModal";

/**
 * SUMMARY-CLASS-1 (s217, rule 120 / D-216.6).
 *
 * 🔴 `accountNumber` was here and is deliberately GONE. This composes a free-text notes blob,
 * and a notes cell is read by every surface that reads notes — so an account number written
 * here is an account number in prose, exactly what rule 120 (and rules 1–4 / CB-1) took out.
 * The account number is extracted into its OWN field, which is where it belongs (rule 121: a
 * value lives on the row it belongs to). Do not put it back.
 */
const DEFAULT_FIELD_LABELS: Record<string, string> = {
  institutionName: "Institution/Company",
  accountType: "Account Type",
  accountHolder: "Account Holder",
  balance: "Balance",
  date: "Date",
  username: "Username",
};

export const PASSWORD_FIELD_LABELS: Record<string, string> = {
  institutionName: "Service/Company",
  accountType: "Account Type",
  username: "Username",
  notes: "Additional Notes",
};

export function formatExtractionAsNotes(
  data: ExtractedData,
  customLabels?: Record<string, string>
): string {
  const labels = customLabels || DEFAULT_FIELD_LABELS;
  const lines: string[] = [];
  lines.push("--- AI Extracted Information ---");

  // SUMMARY-CLASS-1 (s217, rule 120): `rawDescription` is the AI summary, and this function
  // writes it into a NOTES cell — store C, where a summary stops being recognisable as a
  // summary to every downstream reader. The ONLY caller is the card-layout DetailDialog
  // (GenericCategoryPage), whose extraction path never classifies the document, so the class
  // rule can never be satisfied here. Fail closed: the summary is not composed into notes.
  // The extracted FIELD values below are a different job and are untouched.
  
  for (const [key, label] of Object.entries(labels)) {
    const value = data[key as keyof ExtractedData];
    if (value && typeof value === "string" && value.trim()) {
      lines.push(`${label}: ${value}`);
    }
  }
  
  if (data.additionalInfo) {
    for (const [key, value] of Object.entries(data.additionalInfo)) {
      if (value && value.trim()) {
        lines.push(`${key}: ${value}`);
      }
    }
  }
  
  lines.push("--- End AI Extraction ---");
  return lines.join("\n");
}
